import { AxiosResponse } from 'axios';
import AxiosInstanceBFF from './AxiosInstanceBFF';

export const patchBusinessHoursSchedule = async (enabled: boolean, id: string): Promise<AxiosResponse> =>
  AxiosInstanceBFF.patch(`v1/business-hours/change-status/${id}?enabled=${enabled}`);
